module.exports = __webpack_public_path__ + "static/media/Marker Felt-01.8653298f.svg";